import { CustomTransactionItemsErrorResponse } from '@/context/services/transaction_items/type';
import {
  MAXIMUM_VISIBLE_COUNT_REACHED,
  MAXIMUM_VISIBLE_COUNT_REACHED_ON_UPDATE,
} from '@/features/transaction_items/constants';

const VISIBLE_CUSTOM_LIMIT_ERROR_CODES: ReadonlySet<string> = new Set([
  MAXIMUM_VISIBLE_COUNT_REACHED,
  MAXIMUM_VISIBLE_COUNT_REACHED_ON_UPDATE,
]);

/**
 * Returns the first API `messages` entry when the response is the visible-custom limit (create/update).
 * Display as-is (locale comes from the API). 利用中カスタム上限エラー時は API の文言をそのまま返す。
 *
 * Accepts 422 invalid bodies; only `code` / `messages` are read for the limit case.
 */
export function extractVisibleCustomLimitErrorMessage(
  errorResponse: CustomTransactionItemsErrorResponse
): string | null {
  const message = errorResponse.messages?.[0];
  const isLimitError =
    typeof errorResponse.code === 'string' &&
    VISIBLE_CUSTOM_LIMIT_ERROR_CODES.has(errorResponse.code);
  return isLimitError && message ? message : null;
}
